// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"f6a71a7f","977":"eb03f583"}[chunkId] + ".chunk.js";
};